import type { ChatbotApi } from '@liks/backend-svc-api/esm/apis/ChatbotApi';
import type { ChatbotMembership } from '@liks/backend-svc-api/esm/models/index';
import type {
  ChatbotMemberRole,
  ChatbotMembershipWithIdentity,
} from '../types/chatbot';
import { hasMembershipIdentity } from './chatbotServiceGuards';

export async function listMembers(
  chatbotApi: ChatbotApi,
  chatbotId: string,
): Promise<ChatbotMembershipWithIdentity[]> {
  const members =
    await chatbotApi.deLiksChatbotBoundaryChatbotMembershipResourceListChatbotMembers(
      { chatbotId },
    );
  return members.filter(hasMembershipIdentity);
}

export async function inviteMember(
  chatbotApi: ChatbotApi,
  chatbotId: string,
  userId: string,
  role: ChatbotMemberRole,
): Promise<void> {
  await chatbotApi.deLiksChatbotBoundaryChatbotMembershipResourceInviteChatbotMember(
    {
      chatbotId,
      chatbotMembership: { userId, role },
    },
  );
}

export async function updateMemberRole(
  chatbotApi: ChatbotApi,
  chatbotId: string,
  member: ChatbotMembership,
  role: ChatbotMemberRole,
): Promise<void> {
  if (
    typeof member.id !== 'string' ||
    member.id.length === 0 ||
    member.userId == null
  ) {
    throw new Error('Cannot update membership without id and userId');
  }

  await chatbotApi.deLiksChatbotBoundaryChatbotMembershipResourceUpdateChatbotMembership(
    {
      chatbotId,
      id: member.id,
      chatbotMembership: {
        id: member.id,
        userId: member.userId,
        role,
      },
    },
  );
}

export async function removeMember(
  chatbotApi: ChatbotApi,
  chatbotId: string,
  memberId: string,
): Promise<void> {
  await chatbotApi.deLiksChatbotBoundaryChatbotMembershipResourceRemoveChatbotMember(
    { chatbotId, id: memberId },
  );
}
